// extracted by mini-css-extract-plugin
module.exports = {"crossSiteLabel":"wn-z","zenCrossSiteLabel":"xn-z","vrsnlCrossSiteLabel":"yn-z"};